import { useStoreState } from 'easy-peasy';
import PropTypes from 'prop-types';
import React, { useMemo, useEffect, useCallback } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { CustomSelect } from '@ge/components/select';
import { SortDirection } from '@ge/models/constants';
import { globalColors } from '@ge/tokens/colors';

const DropdownWrapper = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 230px);
  margin-top: 10px;
  column-gap: 10px;
  //padding-bottom: 10px;
  //border-bottom: 1px solid ${globalColors.stone1};
  .select__option .option-label {
      margin-left: -10px;
  }
`;


export const EMSeqdropdowns = ({ details, seqDetails, setSelectedSeq }) => {
  const maxWidth = 260;
  const minWidth = 240;
  const { t } = useTranslation(['admin.configure']);
  const { control } = useFormContext();
  const seqValueLabelMap = useMemo(
    () =>
      seqDetails?.data?.map(({ name }) => ({
        label: name.replaceAll('_', ' '),
        value: name,
      })),
    [seqDetails?.data],
  );

  //let selectedSeq = [];
  const handleSeqChange = useCallback((onChange, value) => {
    onChange(value);
    setSelectedSeq(value?.map((val) => val?.value));
  },[setSelectedSeq]);

useEffect(() => {
  if (details && details?.automationsequence?.value?.length > 0) {
    const selectedSequences = details?.automationsequence?.value?.map((val) => {
      const match = seqValueLabelMap?.find((opt) => opt?.label === val);
      return match || { label: val, value: val.replaceAll('', '_') }; // fallback if not found
    });
    //console.log('selectedSequences', selectedSequences);
    control.setValue('sequence', selectedSequences);
  }   
}, [details, seqValueLabelMap]);


  return (
    <>
      <DropdownWrapper itemWidth={maxWidth}>
        <Controller
          control={control}
          name={'sequence'}
          defaultValue={[]}
          rules={{
            required: true,
            validate: (val) => Boolean(val.length),
          }}
          render={({ onChange, onBlur, value }, { invalid }) => (
            <CustomSelect
              placeholder={t('placeholders.select_seq', 'Select Sequences')}
              disabled={false}
              errors={invalid ? 'select minimum one seq' : 'sequence'}
              id={'DL_Seq'}
              label={t('Event_managment.sites', 'Sequence(S)')}
              onSelect={(val) => handleSeqChange(onChange, val)}
              onBlur={onBlur}
              options={seqValueLabelMap}
              value={value}
              isMulti={true}
              searchable={true}
              maxMenuHeight={220}
              maxWidth={maxWidth}
              minWidth={minWidth}
            />
          )}
        />
      </DropdownWrapper>
    </>
  );
};

EMSeqdropdowns.propTypes = {
  details: PropTypes.object,
  seqDetails: PropTypes.array,
  setSelectedSeq: PropTypes.func.isRequired,
};